<template>
  <v-row class="mx-0 pt-3">
    <v-col
      v-for="(item, j) in actionItems"
      :key="j"
      v-show="type === 'action'"
      cols="4"
      class="px-1"
    >
      <v-sheet
        class="pa-2"
        @click="goToLink(item.name)"
        style="border-radius: 15px"
        align="center"
      >
        <v-icon
          :color="(disableProp ? 'grey': item.color)"
          style="font-size: 40px"
        >
          {{item.icon}}
        </v-icon>
        <!--        <v-img-->
        <!--          height="100"-->
        <!--          style="border-radius: 15px"-->
        <!--          :src="item.image"-->
        <!--          :class="{'black-img': disableProp}"-->
        <!--        />-->
        <v-card-text
          style="font-size: 14px;color: #673ab7"
          class="pa-0 mt-2 text-center black--text"
          v-html="$t(item.title)"
        />
      </v-sheet>
    </v-col>
    <v-col
      v-for="(item, index) in listItems"
      :key="'A' + index"
      v-show="type === 'list'"
      cols="4"
      class="px-1 pb-0"
    >
      <v-sheet
        class="pa-2"
        @click="goToLink(item.name)"
        style="border-radius: 15px"
        align="center"
      >
        <v-icon
          :color="(disableProp ? 'grey': item.color)"
          style="font-size: 40px"
        >
          {{item.icon}}
        </v-icon>
        <!--        <v-img-->
        <!--          height="100"-->
        <!--          style="border-radius: 15px"-->
        <!--          :src="item.image"-->
        <!--          :class="{'black-img': disableProp}"-->
        <!--        />-->
        <v-card-text
          style="font-size: 14px;color: #673ab7"
          class="pa-0 mt-2 text-center black--text"
          v-html="$t(item.title)"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
  import General from '@/Mixins/general'
  export default {
    name: 'MDashboardButtons',
    mixins: [General],
    props: ['disableProp', 'type'],
    data: () => ({
      listItems: [],
      actionItems: [],
    }),
    beforeMount () {
      this.listItems = [
        { name: 'mSellList', title: 'sellList', image: '/img/button/sellList.jpg', icon: 'mdi-playlist-plus', color: 'green' },
        { name: 'mDashboard', title: 'mCustomerList', image: '/img/button/returnSellList.jpg', icon: 'mdi-account-details-outline', color: 'orange darken-1' },
        { name: 'mDashboard', title: 'mProductList', image: '/img/button/returnSellList.jpg', icon: 'mdi-package-variant-closed', color: 'purple darken-1' },
        { name: 'mReturnSellList', title: 'mReturnSellList', image: '/img/button/returnSellList.jpg', icon: 'mdi-playlist-minus', color: 'pink' },
      ]
      this.actionItems = [
        { name: 'mSell', title: 'mSell', image: '/img/button/mSell.jpg', icon: 'mdi-cart-plus', color: 'green' },
        { name: 'mReturnSell', title: 'mReturnSell', image: '/img/button/returnSell.jpg', icon: 'mdi-cart-minus', color: 'pink' },
        { name: 'mDashboard', title: 'mCustomer', image: '/img/button/returnSell.jpg', icon: 'mdi-account-plus-outline', color: 'pink' },
      ]
    },
    methods: {
      goToLink (type) {
        if (!this.disableProp) {
          this.goTo(type)
        }
      },
    },
  }
</script>

<style scoped>
.black-img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
</style>
